var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-image',{attrs:{"text":_vm.text,"image":_vm.image,"image-left":_vm.imageLeft,"full-width":true}})}
var staticRenderFns = []

export { render, staticRenderFns }